import { Component, Input } from '@angular/core';
import { NgIconComponent } from '@ng-icons/core';

@Component({
  selector: 'umss-icon',
  standalone: true,
  imports: [NgIconComponent],
  template: `
    <ng-icon
      [name]="name"
      [size]="size"
      [color]="color"
      [strokeWidth]="strokeWidth"
    ></ng-icon>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        ng-icon {
          vertical-align: super;
        }
      }
    `
  ]
})
export class UmssIconComponent {
  /** Icon name from Phosphor Icons (e.g., 'phHeart', 'phStar', 'phCheck') */
  @Input() name!: string;

  /** Icon size in pixels or CSS units */
  @Input() size: string = '24px';

  /** Icon color */
  @Input() color?: string;

  /** Stroke width for outline icons */
  @Input() strokeWidth?: string;
}
